var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconOffCamera = function SvgIconOffCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    rx: 46,
    fill: "#425267"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 46c4.97 0 9-4.253 9-9.5S50.97 27 46 27s-9 4.253-9 9.5 4.03 9.5 9 9.5ZM61.61 51.004a42.062 42.062 0 0 0-31.22 0c-2.065.82-3.39 2.843-3.39 5.126v3.363C27 62.537 29.397 65 32.359 65h27.282C62.603 65 65 62.537 65 59.493V56.13c0-2.283-1.325-4.306-3.39-5.127Z",
    fill: "#9DACC0"
  })));
};
export default SvgIconOffCamera;